class CollectionFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.filterData = [];
    this.isConnectedAndInitialized = false;
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.handleDrawerOpen = this.handleDrawerOpen.bind(this);
    this.handleDrawerClose = this.handleDrawerClose.bind(this);
    this.handleOffDrawerClick = this.handleOffDrawerClick.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handleHistoryChange = this.onHistoryChange.bind(this);
    this.handleDropDownBlur = this.onDropDownBlur.bind(this);
    this.filterFormsId = 'CollectionFiltersForm';
    this.searchTemplate = document.querySelector('#main-body.search-template');
    this.collectionTemplate = document.querySelector('#main-body.collection-template');

    function debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);
  }

  connectedCallback() {
    if (this.isConnectedAndInitialized) return;

    this.form = this.querySelector('form');
    this.productGrid = this.getProductGrid();
    if (!this.form || !this.productGrid) return;

    this.productGridId = this.productGrid.id;
    this.sections = this.getSections();
    this.form.addEventListener('input', this.debouncedOnSubmit);

    this.drawerCloseBtn = this.querySelector('[data-drawer-close-btn]');
    this.drawerOpenBtn = document.querySelector('[data-drawer-open-btn]');

    if (this.drawerCloseBtn && this.drawerOpenBtn) {
      this.drawerOpenBtn.addEventListener('click', this.handleDrawerOpen);
      this.drawerCloseBtn.addEventListener('click', this.handleDrawerClose);
      this.addDrawerListeners();
      window.addEventListener('resize', this.handleResize);
    }

    window.addEventListener('popstate', this.handleHistoryChange);
    document.addEventListener('click', this.handleDropDownBlur);

    if (this.form.id === this.filterFormsId) {
      this.bindActiveFacetButtonEvents();
    }

    this.isConnectedAndInitialized = true;
  }

  disconnectedCallback() {
    if (!this.isConnectedAndInitialized) return;

    this.form.removeEventListener('input', this.debouncedOnSubmit);
    window.removeEventListener('popstate', this.handleHistoryChange);
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('click', this.handleDropDownBlur);
    document.removeEventListener('click', this.handleOffDrawerClick, true);

    if (this.drawerCloseBtn && this.drawerOpenBtn) {
      this.drawerOpenBtn.removeEventListener('click', this.handleDrawerOpen);
      this.drawerCloseBtn.removeEventListener('click', this.handleDrawerClose);
    }

    this.isConnectedAndInitialized = false;
  }

  onDropDownBlur(event) {
    this.querySelectorAll('details[open]').forEach((item) => {
      if (!item.contains(event.target)) item.removeAttribute('open');
    });
  }

  handleResize() {
    this.addDrawerListeners();
    this.setFilterDrawerPosition();
  }

  isHidden(el) {
    return (el.offsetParent === null)
  }

  addDrawerListeners() {
    const filterDrawer = this;
    filterDrawer.removeAttribute('role');
    filterDrawer.removeAttribute('aria-modal');

    if (window.innerWidth < 991) {
      filterDrawer.setAttribute('role', 'dialog');
      filterDrawer.setAttribute('aria-modal', 'true');
      this.setFilterDrawerPosition();
    }

  }

  setFilterDrawerPosition() {
    const header = document.querySelector('[data-header]');
    const filterDrawer = this.querySelector('#CollectionFiltersForm');
    if (!header || !filterDrawer) return;
    filterDrawer.style.top = `${header.offsetHeight}px`;
  }

  handleDrawerOpen(e) {
    e.currentTarget.setAttribute('tabIndex', '-1');
    const filterWrapper = this;

    // filterWrapper.style.visibility = 'visible';
    this.setFilterDrawerPosition();
    filterWrapper.classList.add('is-open');
    document.body.classList.add('scroll-locked');
    this.trapFocus('main-collection-filters', true);

    document.addEventListener('click', this.handleOffDrawerClick, true);
  }

  handleOffDrawerClick(e) {
    const isDrawerClick = this.contains(e.target);

    if (!isDrawerClick) this.handleDrawerClose();
  }

  handleDrawerClose() {
    const filterDrawer = this;
    const filterBtn = this.drawerOpenBtn;

    document.body.classList.remove('scroll-locked');

    filterDrawer.classList.remove('is-open');
    // filterDrawer.style.visibility = 'hidden';
    if (filterBtn) {
      filterBtn.setAttribute('tabIndex', '0');
      filterBtn.focus();
    }
    document.removeEventListener('click', this.handleOffDrawerClick, true);
  }

  trapFocus(slideout_id, is_initial_open) {
    const idString = `#${slideout_id}`;
    const menu = document.getElementById(slideout_id);
    const togglers = document.querySelectorAll('.facets__disclosure, .collection-filters__sort');
    const inputs = document.querySelectorAll(`${idString} input:not([type=hidden]), ${idString} button:not([tabindex="-1"]), ${idString} a:not([tabindex="-1"]), ${idString} textarea`);
    // The first input will always stay the same so we'll declare it here
    const firstInput = inputs[0];
    let lastInput;


    menu.addEventListener('keydown', function (e) {
      const getLastToggler = (togglers[togglers.length - 1]);
      const lastGroupCollapsed = !getLastToggler.hasAttribute('open');

      // If the last tag list is collapsed, the toggle button becomes the 'last input'
      // else the last input is equal to the last input in the array
      lastInput = lastGroupCollapsed ? getLastToggler : (inputs[inputs.length - 1]);

      // Redirect last tab to first input
      if (e.code === 'Tab' && !e.shiftKey && document.activeElement == lastInput) {
        e.preventDefault();
        firstInput.focus();
      }

      // Redirect first shift+tab to last input
      if (e.code === 'Tab' && e.shiftKey && document.activeElement == firstInput) {
        e.preventDefault();
        lastInput.focus();
      }
    });
  }

  onSubmitHandler(event) {
    event.preventDefault();

    if (this.collectionTemplate) {
      const formData = new FormData(event.target.closest('form'));
      const searchParams = new URLSearchParams(formData).toString();
      this.renderPage(searchParams, event);
    } else if (this.searchTemplate) {
      // Store the initial URL so that we can get the search query from it to add to the formData object
      const searchParamsInitial = new URLSearchParams(window.location.search);

      // Get the selected result types, we will need to use them later on
      const activeTypes = document.querySelector('#page-type-input').value;
      const types = Array.from(activeTypes.split(','));
      const defaultTypes = document.querySelector('input#sort-types');

      if (activeTypes == "") {
        const getInput = document.querySelector('#page-type-input');
        getInput.value = defaultTypes.value;
      }

      // Add the initial search query to the formData object otherwise the query will be lost and we will get an error
      const formData = new FormData(event.target.closest('form'));
      formData.append('q', searchParamsInitial.get('q'));

      // If the result type is not of type product, we want to disable the filter inputs and remove product type queries from the URL
      if (types.includes('article') && !types.includes('product') || types.includes('page') && !types.includes('product')) {
        const getInputs = document.querySelectorAll(`#${this.filterFormsId} input:not(#page-type-input)`);
        const getLabels = document.querySelectorAll(`#${this.filterFormsId} label:not(.collection-filters__label)`);

        // Disable the inputs if the result type is article or page
        for (let item of getInputs) {
          item.setAttribute('disabled', 'disabled');
        }

        for (let inputLabel of getLabels) {
          inputLabel.classList.add('facet-checkbox--disabled');
        }

        // If our result is an article or page type, remove all product related filters from the URL
        if (searchParamsInitial.has('filter.p.product_type')) {
          let newFormData = new URLSearchParams(window.location.search).toString();
          formData.delete('filter.p.product_type');
          this.renderPage(newFormData, event);
        }

        if (searchParamsInitial.has('filter.p.vendor')) {
          let newFormData = new URLSearchParams(window.location.search).toString();
          formData.delete('filter.p.vendor');
          this.renderPage(newFormData, event);
        }

        if (searchParamsInitial.has('filter.v.availability')) {
          let newFormData = new URLSearchParams(window.location.search).toString();
          formData.delete('filter.v.availability');
          this.renderPage(newFormData, event);
        }
      }

      const searchParams = new URLSearchParams(formData).toString();
      this.renderPage(searchParams, event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    this.toggleActiveFacets();
    this.renderPage(new URL(event.target.href).searchParams.toString());
  }

  onHistoryChange(event) {
    const searchParams = event.state?.searchParams || '';
    this.renderPage(searchParams, null, false);
  }

  toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  renderPage(searchParams, event, updateURLHash = true) {
    const loadingTarget = this.productGrid.querySelector('[data-product-item-wrapper], .collection');
    if (loadingTarget) loadingTarget.classList.add('loading');

    this.sections.forEach((section) => {
      if (this.collectionTemplate) {
        const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
        const filterDataUrl = element => element.url === url;

        this.filterData.some(filterDataUrl) ?
          this.renderSectionFromCache(filterDataUrl, section, event) :
          this.renderSectionFromFetch(url, section, event);
      } else if (this.searchTemplate) {
        const url = `${window.location.pathname}?${searchParams}`;
        const filterDataUrl = element => element.url === url;

        this.filterData.some(filterDataUrl) ?
          this.renderSectionFromCache(filterDataUrl, section, event) :
          this.renderSectionFromFetch(url, section, event);
      }
    });

    if (updateURLHash) this.updateURLHash(searchParams);
  }

  renderSectionFromFetch(url, section, event) {
    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error(`Unable to render collection section (${response.status})`);
        return response.text();
      })
      .then((responseText) => {
        const html = responseText;
        this.filterData = [...this.filterData, { html, url }];

        switch (section.id) {
          case this.productGridId:
            this.renderProductGrid(html);
            break;
          case this.filterFormsId:
            this.renderFilters(html, event);
            break;
          default:
            return;
        }
      })
      .catch(() => this.handleRenderError());
  }

  renderSectionFromCache(filterDataUrl, section, event) {
    const html = this.filterData.find(filterDataUrl).html;

    switch (section.id) {
      case this.productGridId:
        this.renderProductGrid(html);
        break;
      case this.filterFormsId:
        this.renderFilters(html, event);
        break;
    }
  }

  renderProductGrid(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const sourceGrid = parsedHTML.getElementById(this.productGridId);
    const targetGrid = document.getElementById(this.productGridId);
    if (!sourceGrid || !targetGrid) {
      this.handleRenderError();
      return;
    }

    targetGrid.innerHTML = sourceGrid.innerHTML;
    this.productGrid = targetGrid;
    document.dispatchEvent(new CustomEvent('beyondus:product-cards-updated', {
      detail: { container: targetGrid, source: 'collection-filter' }
    }));
  }

  renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll(`#${this.filterFormsId} .js-filter`);
    const matchesIndex = (element) => element.dataset.index === event?.target.closest('.js-filter')?.dataset.index
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const target = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      if (target) target.innerHTML = element.innerHTML;
    });

    this.renderActiveFacets(parsedHTML);

    if (countsToRender) this.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const target = document.querySelector(selector);
      if (!activeFacetsElement || !target) return;
      target.innerHTML = activeFacetsElement.innerHTML;
    })

    this.bindActiveFacetButtonEvents();
    this.toggleActiveFacets(false);
  }

  renderMobileElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count'];

    mobileElementSelectors.forEach((selector) => {
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('CollectionFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  renderCounts(source, target) {
    const countElementSelectors = ['.count-bubble', '.facets__selected'];
    countElementSelectors.forEach((selector) => {
      const targetElement = target.querySelector(selector);
      const sourceElement = source.querySelector(selector);

      if (sourceElement && targetElement) {
        target.querySelector(selector).outerHTML = source.querySelector(selector).outerHTML;
      }
    });
  }

  bindActiveFacetButtonEvents() {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.addEventListener('click', this.onActiveFilterClick, { once: true });
    });
  }

  updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  handleRenderError() {
    const loadingTarget = this.productGrid?.querySelector('[data-product-item-wrapper], .collection');
    if (loadingTarget) loadingTarget.classList.remove('loading');
    this.toggleActiveFacets(false);
  }

  getProductGrid() {
    const configuredGrid = this.dataset.productGridId && document.getElementById(this.dataset.productGridId);
    if (configuredGrid) return configuredGrid;

    const localGrid = this.closest('[data-collection-product-grid]');
    if (localGrid) return localGrid;

    return document.getElementById('CollectionProductGrid') ||
      document.querySelector('[data-collection-product-grid]');
  }

  getSections() {
    const sections = [{
      id: this.productGridId,
      section: this.productGrid.dataset.sectionId
    }];
    const filterSection = document.getElementById('main-collection-filters');

    if (filterSection) {
      sections.push({
        id: this.filterFormsId,
        section: filterSection.dataset.id
      });
    }

    return sections;
  }
}

customElements.define('collection-filtering-form', CollectionFiltersForm);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', '0');
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range-selector', PriceRange);

class PageType extends HTMLElement {
  constructor() {
    super()
    this.selector = document.querySelector('[data-page-type-selector]');
    this.selector.addEventListener('change', this.setValue);
  }

  setValue(e) {
    const selectedTypes = e.currentTarget.querySelectorAll('input:checked');
    const types = Array.from(selectedTypes).map(option => option.value).join(',');

    const typeInput = document.querySelector('#page-type-input');
    typeInput.value = types;

    const event = new Event('input');
    typeInput.closest('form').dispatchEvent(event);
  }
}

customElements.define('page-type-selector', PageType);
